// import { page } from '$app/stores';
// import { get } from 'svelte/store';

export class ScrollLock {
	public value = -1;
	public page: string | undefined;
	public bind = $state<HTMLElement | undefined>();
	private lockers = new Set<string>();

	public lock = (lockedBy: string) => {
		this.lockers.add(lockedBy);
		if (this.lockers.size > 1) return;

		// this.value = window.scrollY;
		// this.page = get(page)?.url?.pathname;

		// if (!this.bind) return;

		// this.bind.style.position = 'fixed';
		// if (this.value > 0) this.bind.style.top = `-${this.value}px`;
	};

	public unlock = (unlockedBy: string) => {
		this.lockers.delete(unlockedBy);
		if (this.lockers.size > 0 || this.value < 0) return;

		// if (!this.bind) {
		//   this.value = -1;
		//   return;
		// }

		// this.bind.style.removeProperty('position');
		// this.bind.style.removeProperty('top');

		// if (get(page)?.url?.pathname === this.page) {
		//   window.scrollTo(0, Math.abs(this.value));
		// }
		// this.value = -1;
	};
}

export const scrollLock = new ScrollLock();
